import * as React from 'react';
import PropTypes from 'prop-types';
import ProjectDownloader from './ProjectDownloader';
import { useProjectPermissions } from '../useProjectPermissions';

/**
 * ProjectDownloaderOptionsDialog - Project Download Wrapper
 *
 * Wraps ProjectDownloader with ACL permission checking.
 * Opens the complete project download flow directly.
 */
export default function ProjectDownloaderOptionsDialog({ open, onClose, project }) {
  // ACL permission check for download
  const { canDownloadProject } = useProjectPermissions(
    project?.projectId,
    project?.project?.programId
  );

  // Close dialog if user doesn't have download permission
  React.useEffect(() => {
    if (open && !canDownloadProject) {
      console.warn('User does not have permission to download project');
      onClose();
    }
  }, [open, canDownloadProject, onClose]);

  if (!canDownloadProject) return null;

  return (
    <ProjectDownloader
      open={open}
      onClose={onClose}
      project={project}
    />
  );
}

ProjectDownloaderOptionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  project: PropTypes.object,
};
